var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00011 8.86712C6.91344 8.86712 6.82678 8.84712 6.74678 8.80045L0.860097 5.39381C0.626763 5.25381 0.540097 4.94714 0.680097 4.70714C0.820097 4.46714 1.12676 4.38714 1.36676 4.52714L7.00011 7.78712L12.6001 4.54714C12.8401 4.40714 13.1468 4.49381 13.2868 4.72714C13.4268 4.96714 13.3401 5.27381 13.1068 5.41381L7.26011 8.80045C7.17344 8.84045 7.08678 8.86712 7.00011 8.86712Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.906C6.72667 14.906 6.5 14.6794 6.5 14.406V8.35938C6.5 8.08604 6.72667 7.85938 7 7.85938C7.27333 7.85938 7.5 8.08604 7.5 8.35938V14.406C7.5 14.6794 7.27333 14.906 7 14.906Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 15.1666C6.41327 15.1666 5.83327 15.0399 5.37326 14.7866L1.81326 12.8066C0.846595 12.2733 0.0932617 10.9866 0.0932617 9.87992V6.11325C0.0932617 5.00659 0.846595 3.72659 1.81326 3.18659L5.37326 1.21325C6.2866 0.706585 7.71327 0.706585 8.6266 1.21325L12.1866 3.19325C13.1533 3.72659 13.9066 5.01325 13.9066 6.11992V9.88658C13.9066 10.9933 13.1533 12.2733 12.1866 12.8133L8.6266 14.7866C8.1666 15.0399 7.5866 15.1666 6.99994 15.1666ZM6.99994 1.83325C6.57994 1.83325 6.1666 1.91992 5.85994 2.08659L2.29993 4.06659C1.65993 4.41992 1.09326 5.37992 1.09326 6.11325V9.87992C1.09326 10.6133 1.65993 11.5733 2.29993 11.9333L5.85994 13.9133C6.4666 14.2533 7.53327 14.2533 8.13994 13.9133L11.6999 11.9333C12.3399 11.5733 12.9066 10.6199 12.9066 9.87992V6.11325C12.9066 5.37992 12.3399 4.41992 11.6999 4.05992L8.13994 2.07992C7.83327 1.91992 7.41994 1.83325 6.99994 1.83325Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsIcon);
export default __webpack_public_path__ + "static/media/itemsIcon.51109a4776aa4a1ba48713e2356b0395.svg";
export { ForwardRef as ReactComponent };